/**
 * Event constants for the application's event bus
 * Use these constants when dispatching or listening for events to ensure consistency
 */
export const ETHERNET_PRODUCT_STRING = "web-app-ethernet";
export const MASK = '*********';
export const masks = [
  'password',
  'new_password'
];

// Navigation related events
export const NAVIGATION_EVENTS = {
  ROUTE_CHANGE: "route_change",
};

// User action events
export const USER_EVENTS = {
  // signup differs from creds generation
  USER_SIGNUP: "user_signup_success",
  USER_SIGNUP_ERROR: "user_signup_error",
};

// Click events
export const CLICK_EVENTS = {
  BTN_CLICK: "btn_click",
};

// API related events
export const API_EVENTS = {
  API_ERROR: "api_error",
  API_SUCCESS: "api_success",
};

export const VENUE_DETAILS_ERROR_STRING = "Error loading venue details. Please try again later.";

// Add more event categories as needed
